import AdminHttpService from "admin/common/adminHttpService";
import ThrowsValidationError from "common/http/throwsValidationError";
import { CustomField, CustomFieldGroup } from "domain/customField";

class CustomFieldService extends AdminHttpService {
    async listCustomFields(merchantId: string): Promise<CustomField[]> {
        const result = await this.getClient().get<CustomField[]>(`/offers/v1/merchants/${merchantId}/custom-fields`);
        return result.data;
    }

    @ThrowsValidationError()
    async createCustomField(merchantId: string, request: CustomField): Promise<CustomField> {
        const result = await this.getClient().post(`/offers/v1/merchants/${merchantId}/custom-fields`, request);
        return result.data;
    }

    @ThrowsValidationError()
    async updateCustomField(merchantId: string, request: CustomField): Promise<CustomField> {
        const result = await this.getClient().put(`/offers/v1/merchants/${merchantId}/custom-fields/${request.id}`, request);
        return result.data;
    }

    async deleteCustomField(merchantId: string, customFieldId: string): Promise<void> {
        await this.getClient().delete(`/offers/v1/merchants/${merchantId}/custom-fields/${customFieldId}`);
    }

    async listCustomFieldGroups(merchantId: string): Promise<CustomFieldGroup[]> {
        const result = await this.getClient().get<CustomFieldGroup[]>(`/offers/v1/merchants/${merchantId}/custom-field-groups`);
        return result.data;
    }

    @ThrowsValidationError()
    async createCustomFieldGroup(merchantId: string, request: CustomFieldGroup): Promise<CustomFieldGroup> {
        const result = await this.getClient().post(`/offers/v1/merchants/${merchantId}/custom-field-groups`, request);
        return result.data;
    }

    @ThrowsValidationError()
    async updateCustomFieldGroup(merchantId: string, request: CustomFieldGroup): Promise<CustomFieldGroup> {
        const result = await this.getClient().put(`/offers/v1/merchants/${merchantId}/custom-field-groups/${request.id}`, request);
        return result.data;
    }

    async deleteCustomFieldGroup(merchantId: string, customFieldGroupId: number): Promise<void> {
        await this.getClient().delete(`/offers/v1/merchants/${merchantId}/custom-field-groups/${customFieldGroupId}`);
    }
}

const customFieldService = new CustomFieldService();
export default customFieldService;